// JavaScript source code
import React, { useState, useEffect} from 'react';

import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
function Agreement(props) {
    let activeIndex = 3;

    useEffect(() => {

    }, []);
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
   
    return (
        <div className="mydelian agreement" >
            <SubHeader activeIndex={activeIndex} />
            <div className="content">
                <div className="detail">
                <h4>德联车护官网用户注册协议</h4>

                <h6>一、协议主体与接受</h6>
                <p>本协议由您（以下称“用户”或“您”）与德联车护网络发展有限公司（以下称“本网站”或“我们”）之间就德联车护官网提供的服务（以下称“服务”）所订立的契约。请您在注册成为本网站用户之前，认真阅读本协议的全部内容，特别是以加粗形式提示您注意的部分。若您已经阅读并充分理解本协议的全部内容，同意遵守本协议的各项条款并完成注册程序，那么您即表示接受本协议的全部内容。此后，您不得以未阅读本协议的内容或者未获得本网站对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</p>

                <h6>二、账号注册</h6>
                <p>1.	用户注册时应提供真实、准确、完整、合法有效的信息，包括但不限于您的姓名、性别、电子邮箱、手机号码、微信号、QQ号等。若您提供的信息存在任何不真实、不准确、不完整、不合法有效的情形，本网站有权暂停或终止向您提供服务。
                    </p><p>    2.	用户注册成功后，将得到一个用户账号及相应的密码，该账号和密码由用户负责保管；用户应当对以其用户账号进行的所有活动和事件负法律责任。
                </p>
                <h6>三、服务内容</h6>
                <p>本网站提供的服务包括但不限于信息浏览、在线交流、在线交易、会员特权等。具体服务内容以本网站实际情况为准。</p>
                <h6>四、用户行为规范</h6>
                <p>1.	用户在使用本网站服务时，应遵守中华人民共和国的法律法规，不得利用本网站从事任何非法活动。
                    </p><p>     2.	用户不得在本网站发布任何涉及政治敏感、色情、暴力、恶意攻击、虚假宣传等违法违规信息。
                    </p><p>     3.	用户应尊重他人的知识产权，不得在本网站发布、传播侵犯他人知识产权的内容。
                    </p><p>     4.	用户应遵守本网站的社区规则，不得进行恶意刷单、刷评、虚假交易等行为。
</p>
                <h6>五、隐私保护</h6>
                <p>1.	本网站尊重并保护用户的隐私权，未经用户同意，不会向任何第三方披露用户的个人信息。
                    </p><p>    2.	本网站将采取必要的技术手段和管理措施，确保用户个人信息安全。
</p>
                <h6>六、免责声明</h6>
                <p>1.	用户应自行承担使用本网站服务的风险，本网站对任何因使用本网站服务而产生的直接或间接损失不承担责任。
                    </p><p>    2.	因不可抗力因素（如自然灾害、网络故障等）导致本网站服务中断或无法正常使用时，本网站不承担任何责任。
</p>
                <h6>七、协议变更与终止</h6>
                <p>1.	本网站有权根据业务需要对本协议进行不定期的修订，并通过本网站公告的方式告知用户。修订后的协议一经公布即自动生效，您应随时关注本网站的公告信息。
                    </p><p>    2.	若用户违反本协议的规定，本网站有权暂停或终止向您提供服务。
</p>
                <h6>八、争议解决</h6>
                <p>1.	如双方就本协议的履行发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向本网站所在地的人民法院提起诉讼。
                    </p><p>    2.	本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。
</p>
                <h6>九、其他</h6>
                <p>1. 本协议自用户完成注册程序之日起生效，至用户注销账号或本网站终止向您提供服务时终止。</p>
                    <p>2. 本协议的最终解释权归本网站所有。</p>
                </div>

            </div>            
            
            <SubFooter />
           
        </div>          
    );
}
export default Agreement;